import {Component, HostBinding} from '@angular/core';
import {enterLeaveOpacityAnimation} from '../../../shared/animations/show-opacity.animation';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
  animations: [
    enterLeaveOpacityAnimation
  ]
})
export class SearchFilterComponent {
  @HostBinding('@enterLeaveOpacity') animate: boolean = true;
}
